exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-group, .form-group .form-group-inner {\n  position: relative;\n}\n.form-group .activity-indicator {\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translate(-1rem, -50%);\n  transition: all 0.25s ease-in;\n}", ""]);

// exports
